import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useClient } from "../../common/ClientProvider";
import { ShiftChecklistService } from "./ShiftChecklistService";

interface ShiftChecklistServiceProviderProps {
  children: React.ReactNode;
}

export const ShiftChecklistServiceContext = React.createContext<
  ShiftChecklistService | undefined
>(undefined);

export const ShiftChecklistServiceProvider: React.FC<
  ShiftChecklistServiceProviderProps
> = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0();
  const { currentClientId } = useClient();

  const service = React.useMemo(() => {
    return new ShiftChecklistService(getAccessTokenSilently, currentClientId);
  }, [getAccessTokenSilently, currentClientId]);

  return (
    <ShiftChecklistServiceContext.Provider value={service}>
      {children}
    </ShiftChecklistServiceContext.Provider>
  );
};

export const useShiftChecklistService = (): ShiftChecklistService => {
  const context = React.useContext(ShiftChecklistServiceContext);
  if (context === undefined) {
    throw new Error(
      "useShiftChecklistService must be used within a ShiftChecklistServiceProvider"
    );
  }
  return context;
};
